import type { CSSProperties } from "react";
import classes from "./ToastWrapper.module.css";

interface IToastWrapperProps {
  children: React.ReactNode;
  style?: CSSProperties;
  className?: string;
}

export default function ToastWrapper({ children, style, className }: IToastWrapperProps) {
  const classList = [classes.ToastWrapper];
  if (className) classList.push(className);

  return (
    <div className={classList.join(" ")} style={style}>
      {children}
    </div>
  );
}
